import React from 'react';
import { graphql, compose } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import Spinner from '../../spinner/spinner';
import { Button, Form, Row, Col } from 'antd';
import UploadScriptureForm from './dailyScripturesForm';
import { getDailyScripture } from "./queries/getDailyScripture";
import { updateDailyScripture } from "./mutations/updateDailyScripture";

const onCancelClick = (history) => { history.push("/dashboard/admin/scripturesList/") };

class EditScripturePage extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          day: parseInt(this.props.form.getFieldValue('day'), 10),
          id: parseInt(this.dailyScripture.id)
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/scripturesList?scripture=${data.updateDailyScripture.dailyScripture.id}`);
  };

  get dailyScripture() {
    return this.props.data.dailyScripture;
  }

  formControls(loading) {
    return (
      <Row type="flex" justify="end" className="align-right">
        <Col xs={{ span: 24, order: 1 }} md={{ span: 6, order: 0 }}>
          <Button onClick={() => { onCancelClick(this.props.history) }} className="daily-scriptures-list__control">
            Cancel Updates
          </Button>
        </Col>
        <Col xs={{ span: 24, order: 0 }} md={{ span: 6, offset: 1, order: 1 }}>
          <Button type="primary" htmlType="submit" className="daily-scriptures-list__control" loading={loading}>
            Save Updates
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else if (this.dailyScripture) {
      return (
        <UploadScriptureForm {...this.props } dailyScripture={this.dailyScripture}
                             formControls={this.formControls.bind(this)}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}
                             onSubmit={this.onSubmit}/>
      );
    } else {
      return <Redirect to="/404" />;
    }
  }
}
export default Form.create()(
  compose(
    graphql(getDailyScripture, {
      options: ({ match }) => ({
        variables: { scriptureId: parseInt(match.params.scriptureId, 10) },
        fetchPolicy: 'cache-and-network'
      })
    }),
    graphql(updateDailyScripture)
  )(EditScripturePage)
);



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/editScripture.js